// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"c62026b1","170":"36c05ffc","373":"b8eca333","568":"83c345e3","762":"b1835bc2","835":"d73415e6","994":"8b27778d"}[chunkId] + ".chunk.js";
};